import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UiDefaultHookQueryVariables = Types.Exact<{
  args: Types.GetUiDefaultInput;
}>;


export type UiDefaultHookQuery = { readonly __typename?: 'Query', readonly UiDefault?: { readonly __typename?: 'UiDefault', readonly id: string, readonly namespace: string, readonly name: string, readonly scope: Types.DefaultScope, readonly value: unknown } | null };

export type UiDefaultHookUpsertMutationVariables = Types.Exact<{
  args: Types.UpsertUiDefaultInput;
}>;


export type UiDefaultHookUpsertMutation = { readonly __typename?: 'Mutation', readonly upsertUiDefault: { readonly __typename?: 'UiDefault', readonly id: string, readonly namespace: string, readonly name: string, readonly scope: Types.DefaultScope, readonly value: unknown } };


export const UiDefaultHookDocument = gql`
    query uiDefaultHook($args: GetUiDefaultInput!) {
  UiDefault(input: $args) {
    id
    namespace
    name
    scope
    value
  }
}
    `;

/**
 * __useUiDefaultHookQuery__
 *
 * To run a query within a React component, call `useUiDefaultHookQuery` and pass it any options that fit your needs.
 * When your component renders, `useUiDefaultHookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUiDefaultHookQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useUiDefaultHookQuery(baseOptions: Apollo.QueryHookOptions<UiDefaultHookQuery, UiDefaultHookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UiDefaultHookQuery, UiDefaultHookQueryVariables>(UiDefaultHookDocument, options);
      }
export function useUiDefaultHookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UiDefaultHookQuery, UiDefaultHookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UiDefaultHookQuery, UiDefaultHookQueryVariables>(UiDefaultHookDocument, options);
        }
export type UiDefaultHookQueryHookResult = ReturnType<typeof useUiDefaultHookQuery>;
export type UiDefaultHookLazyQueryHookResult = ReturnType<typeof useUiDefaultHookLazyQuery>;
export type UiDefaultHookQueryResult = Apollo.QueryResult<UiDefaultHookQuery, UiDefaultHookQueryVariables>;
export const UiDefaultHookUpsertDocument = gql`
    mutation uiDefaultHookUpsert($args: UpsertUiDefaultInput!) {
  upsertUiDefault(input: $args) {
    id
    namespace
    name
    scope
    value
  }
}
    `;
export type UiDefaultHookUpsertMutationFn = Apollo.MutationFunction<UiDefaultHookUpsertMutation, UiDefaultHookUpsertMutationVariables>;

/**
 * __useUiDefaultHookUpsertMutation__
 *
 * To run a mutation, you first call `useUiDefaultHookUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUiDefaultHookUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uiDefaultHookUpsertMutation, { data, loading, error }] = useUiDefaultHookUpsertMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useUiDefaultHookUpsertMutation(baseOptions?: Apollo.MutationHookOptions<UiDefaultHookUpsertMutation, UiDefaultHookUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UiDefaultHookUpsertMutation, UiDefaultHookUpsertMutationVariables>(UiDefaultHookUpsertDocument, options);
      }
export type UiDefaultHookUpsertMutationHookResult = ReturnType<typeof useUiDefaultHookUpsertMutation>;
export type UiDefaultHookUpsertMutationResult = Apollo.MutationResult<UiDefaultHookUpsertMutation>;
export type UiDefaultHookUpsertMutationOptions = Apollo.BaseMutationOptions<UiDefaultHookUpsertMutation, UiDefaultHookUpsertMutationVariables>;